export default __webpack_public_path__ + "static/apple-core-image-c0dc56d96586f5b21e291ac586b956ca.png";